import {writable} from 'svelte/store';

let samplesObject = {
    list: null,
    total: 0,
    page: 1,
    selectedId: null,
    sampleIsDirty: false,

    search: {
        code: null,
        type: null,
        characterization: null,
        offset: 0,
        limit: null,
        sort_field: null,
        sort_way: null,
    },

    changed: false,
    scrollY: null,
};

const {get, set, update, subscribe} = writable(samplesObject);

const samples = {
    set,
    update,
    subscribe,

    clearSearch: () => {
        samples.update(obj => {
            obj.search.code = null;
            obj.search.type = null;
            obj.search.characterization = null;
            obj.search.offset = 0;
            obj.page = 1;
            return obj;
        });
    }
}

export default samples;